import { Card, Typography } from "antd";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function DonaProgreso({ title, labels, data, colors }) {
  const chartData = {
    labels,
    datasets: [
      {
        label: title,
        data,
        backgroundColor: colors,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    cutout: "50%",
    plugins: {
      legend: {
        position: "top",
        align: "start",
        labels: {
          boxWidth: 12,
          padding: 10,
          font: { size: 10 }
        },
      },
      tooltip: { enabled: true },
      // Scoped datalabels configuration for this chart only
      datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
          size: 11
        },
        formatter: (value, context) => {
          const datapoints = context.chart.data.datasets[0].data;
          const totalValue = datapoints.reduce((total, datapoint) => total + datapoint, 0);
          const percentageValue = ((value / totalValue) * 100).toFixed(0);
          return percentageValue > 5 ? `${percentageValue}%` : ""; // Only show if segment is big enough
        },
        display: true,
      }
    },
  };

  return (
    <>
      {data ? (
        <Doughnut 
          data={chartData} 
          options={options} 
          plugins={[ChartDataLabels]} // Specific plugin instance for this chart
        />
      ) : (
        <Typography.Text>Loading...</Typography.Text>
      )}
    </>
  );
}
